module.exports = [
    {
        title: '未读',
        listApi: '/app/item/list',
        detailApi: '/app/item/detail',
        dateTitle: '发起时间',
        params: {
            checked: 0,
        },
        data: [],
        target: 'NormalDetail',
        subTarget: 'messageDetail',
    },
    {
        title: '全部',
        listApi: '/app/item/list',
        detailApi: '/app/item/detail',
        dateTitle: '发起时间',
        params: {
        },
        data: [],
        target: 'NormalDetail',
        subTarget: 'messageDetail',
    },
]
